<template>
  <div>
    <a-modal
      :title="tenant.id?'编辑客户':'新增客户'"
      :width="600"
      :maskClosable="false"
      destroyOnClose
      :visible="visible"
      :confirmLoading="confirmLoading"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <a-form 
        :form="form"
        :autoFormCreate="(form)=>{this.form = form}">
        <a-form-item
          label="客户简称"
          hasFeedback
          :labelCol="{ span: 5 }"
          :wrapperCol="{ span: 17 }">
          <a-input
            v-decorator="[
              'tenancyName',
              {
                initialValue:tenant.tenancyName,
                rules: [{ required: true, message: '请输入客户简称' }]}
            ]"
          />
        </a-form-item>
        <a-form-item
          label="客户名称"
          hasFeedback
          :labelCol="{ span: 5 }"
          :wrapperCol="{ span: 17 }">
          <a-input
            v-decorator="[
              'name',
              {initialValue:tenant.name,rules: [{ required: true, message: '请输入客户名称' }]}
            ]"
          />
        </a-form-item>
        <a-form-item
          label="数据库连接"
          hasFeedback
          :labelCol="{ span: 5 }"
          :wrapperCol="{ span: 17 }">
          <a-input
            v-decorator="[
              'dbConnection',
              {initialValue:tenant.dbConnection,rules: [{ required: true, message: '请输入数据库连接' }]}
            ]"
          />
        </a-form-item>
        <a-form-item
          label="是否激活"
          :labelCol="{ span: 5 }"
          :wrapperCol="{ span: 17 }">
          <a-switch 
            checkedChildren="开" 
            unCheckedChildren="关" 
            v-decorator="[
              'isActive',
              { initialValue:tenant.isActive,valuePropName:'checked'}
            ]"
          />
        </a-form-item>
        <a-form-item
          label="到期日期"
          :labelCol="{ span: 5 }"
          :wrapperCol="{ span: 17 }">
          <a-date-picker
            v-decorator="[
              'expireDate',
              {initialValue:moment(tenant.expireDate),rules: [{ required: true,type:'object', message: '请选择日期' }]}
            ]"
          />
        </a-form-item>
        <a-form-item
          label="手机"
          hasFeedback
          :labelCol="{ span: 5 }"
          :wrapperCol="{ span: 17 }">
          <a-input
            v-decorator="[
              'mobile',
              {initialValue:tenant.mobile,rules: [{ required: true, message: '请输入联系手机' }]}
            ]"
          />
        </a-form-item>
        <a-form-item
          label="联系人"
          hasFeedback
          :labelCol="{ span: 5 }"
          :wrapperCol="{ span: 17 }">
          <a-input
            v-decorator="[
              'contact',
              {initialValue:tenant.contact,rules: [{ required: true, message: '请输入学校联系人' }]}
            ]"
          />
        </a-form-item>
        <a-form-item
          label="价格"
          :labelCol="{ span: 5 }"
          :wrapperCol="{ span: 17 }">
          <a-input-number
            v-decorator="[
              'price',
              {initialValue:tenant.price,rules: [{ required: true}]}
            ]"
          />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>
<script>
import {mapState,mapActions} from 'vuex'
import { deepmerge } from '@/utils/util'

export default {
  model: {
    prop: 'visible',
    event: 'change'
  },
  props:{
    visible:{
      type:Boolean,
      default:false
    }
  },
  data(){
    return{
      confirmLoading:false,
      form:null
    }
  },
  methods:{
    ...mapActions('tenant',['updateOrAdd']),
    handleOk(){
      this.form.validateFields((error,values)=>{
        if(!error){ 
          const expireDate=values.expireDate.format('YYYY-MM-DD')         
          const tenant=deepmerge.merge(true,{},this.tenant)
          deepmerge.merge(true,tenant,values)
          tenant.expireDate=expireDate
          this.confirmLoading=true
          this.updateOrAdd(tenant).then(()=>{
            this.confirmLoading=false
            this.$message.success('保存成功',1)
            this.$emit('change',false)
          })
        }
      })
    },
    handleCancel(){
      this.$emit('change',false)
    }
  },
  computed:mapState({
    tenant:state=>state.tenant.editTenant,
    editions:state=>state.tenant.editions,
    disabled:state=>state.tenant.disabled
  })
}
</script>
<style lang="scss" scoped>
.empty-tip{
  margin-top: 10px;
}
</style>


